/**
 * 优惠券历史记录
 */
import React from "react";
import { Row, DatePicker, Tooltip, Button } from "antd";
import moment from "moment";
import PageLayout from "../../ui/PageLayout";
import MemberCouponDetail from "./MemberCouponDetail";
const { MonthPicker } = DatePicker;

class CouponList extends React.Component {
  columns = [
    {
      title: "商户名",
      dataIndex: "memberName",
      width: "40%",
    },
    {
      title: "已使用优惠时长",
      dataIndex: "hourUsed",
      width: "20%",
    },
    {
      title: "使用次数",
      dataIndex: "count",
      width: "20%",
    },
    {
      title: "详情",
      render: (text, record, index) => (
        <div>
          <Tooltip title="详情">
            <Button type="primary" onClick={this.showDetail.bind(this, record)}>
              详情
            </Button>
          </Tooltip>
        </div>
      ),
      width: "20%",
    },
  ];

  state = {
    loadData: "",
    queryData: {},
    detailMemberCode: "",
    detailMemberName: "",
    month: moment().format("YYYY-MM"),
  };

  getData(month) {
    if (!month) month = this.state.month;
    var queryData = { month };
    this.setState({ queryData });
    this.state.loadData(queryData);
  }
  componentWillMount() {
    this.setState({
      month: moment().format("YYYY-MM"),
    });
  }
  onMonthChange = (date, dateString) => {
    this.setState({ month: dateString });
    this.getData(dateString);
  };

  hideModal = () => {
    this.setState({ visible: false });
  };

  showDetail = (record, e) => {
    this.setState({
      visible: true,
      detailMemberCode: record.memberCode,
      detailMemberName: record.memberName,
    });
  };
  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              查询月份
              <MonthPicker
                onChange={this.onMonthChange}
                value={moment(this.state.month)}
              />
            </Row>
          }
          rowKey="memberCode"
          url="/barrier/queryMemberCoupon"
          columns={this.columns}
          initParams={{ month: this.state.month }}
          loadData={(func) => {
            this.setState({
              loadData: func,
            });
          }}
        />
        <MemberCouponDetail
          visible={this.state.visible}
          memberCode={this.state.detailMemberCode}
          memberName={this.state.detailMemberName}
          month={this.state.month}
          onCancel={this.hideModal.bind(this)}
        />
      </div>
    );
  }
}

export default CouponList;
